/**
 * Read the store
 * @param {string} name
 * @return {Promise<string | undefined>}
 */
export function readStore(
    name: string,
): Promise<string | undefined> {
  return new Promise((resolve) => {
    const data = localStorage.getItem(name);
    if (data) {
      resolve(data);
    } else return undefined;
  });
}

/**
 * Write the store
 * @param {string} name
 * @param {string} content
 * @return {Promise<void | Error>}
 */
export function writeStore(
    name: string,
    content: string,
): Promise<void | Error> {
  return new Promise<void>((resolve) => {
    localStorage.setItem(name, content);
    resolve();
  });
}
